<ng-container [formGroup]="formGroup">
  <div [class.nowrap]="!wrapLabelText">
    <lds-select
      formControlName="field"
      name="{{ identifier }}"
      identifier="{{ identifier }}"
      [label]="label"
      [options]="['Yes', 'No'] | ldsSelectOption"
      [isRequired]="isRequired"
      [showHighlight]="showHighlight"
      [validations]="{
        required: 'Please select an option'
      }">
    </lds-select>
  </div>
</ng-container>
